import ColumnChangeItem, {
  ChangesList,
} from 'shared/components/ColumnChangeItem';
import { CloudDataContractChangeDetail } from 'shared/types/execution';

type Props = {
  changes: CloudDataContractChangeDetail[];
};

const CloudDataContractList = ({ changes }: Props) => (
  <ChangesList>
    {changes.map((change, idx) => {
      const {
        columnName,
        changeType,
        dataType,
        previousDataType,
        isNullable,
        previousIsNullable,
        dependencyImpact,
      } = change;

      return (
        <ColumnChangeItem
          key={`${columnName}-${changeType}-${idx}`}
          columnName={columnName}
          changeType={changeType}
          dataType={dataType}
          previousDataType={previousDataType}
          isNullable={isNullable}
          previousIsNullable={previousIsNullable}
          {...dependencyImpact}
        />
      );
    })}
  </ChangesList>
);

export default CloudDataContractList;
